import React, { ReactNode } from 'react'
import { UserPermission } from 'src/constants/user'
import { useSelector } from 'react-redux'
import { getAccessInfo } from 'src/selectors/user'
import { NavigateToInitialRoute } from '../layout/NavigateToInitialRoute'

interface Props {
  permissions: UserPermission[]
  children?: ReactNode
  withNavigate?: boolean
}

export const ProtectedWithSomePermission = ({ permissions, children, withNavigate }: Props) => {
  const accessInfo = useSelector(getAccessInfo)

  const hasSomePermission = permissions.some((perm) => accessInfo?.permissions?.includes(perm))

  if (!hasSomePermission) {
    return withNavigate ? <NavigateToInitialRoute /> : null
  }

  return <>{children}</>
}
